module.exports = __webpack_public_path__ + "static/media/qgen.3b68e91e.png";